var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loginStatus)?_c('Login',{on:{"closed":function($event){_vm.loginStatus = false},"loginSuccess":_vm.nextPay}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }